// ============================================================================
// post-client-mod -- Mod 定义
//
// 提供：
// 1. 用户中心 Slot — "我的文章"管理面板（写操作，需要登录）
// 2. 公开页面    — /post 文章列表 + /post/:id 文章详情（给访客浏览）
// 3. PostApiClient  — HTTP API 客户端（支持 DI 注入 IFetchService）
// ============================================================================
import { USER_CENTER_SLOTS_INTERFACE_TAG } from '@hvsin/user-center-contracts';
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG } from '@hvsin/ui-registry-contracts';
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
import { PostRegistrar } from './post-registrar.js';
import { PostApiClient } from './post-api-client.js';
export const postClientMod = {
    name: 'post-client',
    serviceDefs: [
        {
            serviceTag: 'postRegistrar',
            serviceImpl: PostRegistrar,
            dependencies: [
                USER_CENTER_SLOTS_INTERFACE_TAG,
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                FETCH_SERVICE_INTERFACE_TAG,
            ],
        },
        {
            serviceTag: 'postApiClient',
            serviceImpl: PostApiClient,
            dependencies: [FETCH_SERVICE_INTERFACE_TAG],
        },
    ],
};
//# sourceMappingURL=mod.js.map